import Vue from 'vue';
import Cookies from 'js-cookie';

import 'normalize.css/normalize.css'; // a modern alternative to CSS resets

import Element from 'element-ui';
import './styles/element-variables.scss';
// import enLang from 'element-ui/lib/locale/lang/en'// 如果使用中文语言包请默认支持，无需额外引入，请删除该依赖
import 'vant/lib/index.css'
import '@/styles/index.scss'; // global css
import App from './App';
import store from './store';
import router from './router';
import utils from './utils/new';
require('@/utils/flexible');
import './plugins/vant';
import './icons'; // icon
import './permission'; // permission control

import * as filters from './filters'; // global filters
import { JSEncrypt } from 'jsencrypt';
import { getToken } from '@/utils/auth';
// import XML from './utils/XMLrequest'
import dict from './utils/dict';
/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */
// if (process.env.NODE_ENV === 'production') {
//   const { mockXHR } = require('../mock')
//   mockXHR()
// }

// 自定义指令注册
import { loadHas } from './utils/directive';
import VueCropper from 'vue-cropper';
import compressImg from '@/utils/compressor';

loadHas();
Vue.use(VueCropper);
Vue.prototype.$compressImg = compressImg;
Vue.prototype.$moment = utils.moment;

// 绑定全局共用方法 moment setFormValue
Vue.prototype.$utils = utils;

Vue.use(Element, {
  size: Cookies.get('size') || 'medium', // set element-ui default size
  // locale: enLang // 如果使用中文，无需设置，请删除
});
// import Console from 'vconsole';
// const v = new Console();
// Vue.use(v);
// Vue.prototype.$layer = layer(Vue);
// register global utility filters
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});

Vue.config.productionTip = false;

Vue.prototype.$PORTAL = process.env.VUE_APP_BASE_PORTAL;
Vue.prototype.$URL = process.env.VUE_APP_BASE_API;
Vue.prototype.$UPLOAD = process.env.VUE_APP_HOST_UPLOAD;
// Vue.prototype.$URL = 'http://10.100.23.108:8082';
window.$URL = process.env.VUE_APP_BASE_API;
window.$H5URL = process.env.VUE_APP_H5_URL;
window.$WSURL = process.env.VUE_APP_WS_URL;
window.getToken = getToken;
// Vue.prototype.$Timing = 60
// Vue.prototype.$XML = XML;

// 字典配置库
Vue.prototype.$dict = dict;

// 密码加码
Vue.prototype.$getCode = function (password) {
  // 创建RSAKey对象
  var publicKey =
    'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCFH5SmZ7l7dxExRqNn6uwlk/' +
    'JRwB97r8bu4xEMKCIdkJIwBfsIX+cAXLPH+03Y3j34OM9Ct8r3XGlgR6RBOrkBU0BE5xLcDfajrh771' +
    'k3udAQCNHxqFVvKLaPTjLXy1eIHnBHtcoDB3lOaoJOanGigBRES0taVludkz7GoyjfkSwIDAQAB';
  var jsencrypt = new JSEncrypt();

  jsencrypt.setPublicKey(publicKey);
  return jsencrypt.encrypt(password);
};

const vm = new Vue({
  el: '#app',
  router,
  store,
  render: (h) => h(App),
});

Vue.use({
  vm,
});
